/**
 *
 * @author fuyg
 * @date  2020-06-08
 */
import { axios, API_PREFIX } from 'src/http'

const theApi = `${API_PREFIX}/pub/news/appearYears`

async function getAppearYears(): Promise<number[]> {
  const url = theApi
  const response = await axios.get(url)
  return response.data.data
}

export { getAppearYears }
